<info-modal [title]="title" (onOk)="ok()"><iframe style="width: 100%; height: 500px; border: 0px;" #iframe></iframe></info-modal>